import slugify from 'slugify';
import joypixels from 'emoji-toolkit';

export const clamp = (num: number, min: number, max: number) => Math.min(Math.max(num, min), max);

export function FormatNumber(value: any, ceil = true) {
  try {
    if (isNaN(value)) return 0;
    return Intl.NumberFormat('pt-BR').format(ceil ? Math.ceil(value) : value);
  } catch (e) {
    return isNaN(value) ? 0 : value;
  }
}

export function stringToSearchPlayers(text: string) {
  if (typeof text !== 'string') return '';

  try {
    return slugify(text, ' ')
      .replace(/[.·/_\-,:;]+/g, ' ')
      .replace(/[\s]+/g, ' ')
      .trim()
      .toUpperCase();
  } catch (e) {
    return text
      .replace(/[.·/_\-,:;]+/g, ' ')
      .replace(/[\s]+/g, ' ')
      .trim()
      .toUpperCase();
  }
}

export function getIndexByValue(array: any, value: string) {
  return array.findIndex((element: any) => element.value === value);
}

export function stripHtmlTags(str: string) {
  try {
    if (str === null || str === '') return '';
    else str = str.toString();
    return str.replace(/<[^>]*>/g, '');
  } catch (e) {
    return str;
  }
}

export function convertEmojis(str: string) {
  const styles = [`width: 1.25em`, `height: auto`, 'display: inline-block', 'position: relative', 'top: -1px'];

  if (typeof str === 'string' && str.length) {
    return (joypixels.toImage(str) as string)
      .split(`<img class="joypixels"`)
      .join(`<img class="joypixels" style="${styles.join(';')}"`);
  } else {
    return '';
  }
}

// Retorna a etapa atual da Realização
export function getTaskStep(task: any) {
  if (!task || typeof task.status !== 'string') return undefined;

  // Etapa 2
  if (
    (task.status === 'rejeitado' || task.status === 'aguardando') &&
    (typeof task.stageNumber === 'undefined' || task.stageNumber === 0)
  ) {
    return 2;
  }

  // Se tiver Pit Stop
  if (typeof task.prosseguir_gst === 'string') {
    if (task.prosseguir_gst === 'next' || task.prosseguir_gst === 'stopped') {
      return 4.1;
    } else {
      return 5;
    }
  }

  // Etapa 3, 4 e 5
  if (typeof task.multiplicador === 'number') {
    if (typeof task.stageNumber === 'number') {
      if (task.stageNumber === 1) {
        return 3;
      } else if (task.stageNumber === 2) {
        return 4;
      } else if (task.stageNumber === 3) {
        return 5;
      }
    } else {
      // Etapa 3
      if (task.multiplicador === 1) {
        return 3;
      }

      // Etapa 3
      if (task.status === 'dobrado' && task.multiplicador === 2) {
        return 3;
      }

      // Etapa 4
      if (task.status === 'promovido' && task.multiplicador === 2) {
        return 4;
      }

      // Etapa 4
      if (task.status === 'dobrado' && task.multiplicador === 4) {
        return 4;
      }

      // Etapa 5
      if (task.status === 'promovido' && task.multiplicador === 4) {
        return 5;
      }

      // Etapa 5
      if (task.status === 'dobrado' && task.multiplicador === 8) {
        return 5;
      }

      // Etapa 5
      if (task.status === 'selo') {
        return 5;
      }
    }
  }

  return undefined;
}

export const getPerformanceCategory = (percentage: number): JSX.Element => {
  if (percentage >= 10 && percentage <= 20) {
    return (
      <p>
        <strong>10% a 20%: Atuação Pontual</strong>: Tarefas simples ou assistenciais ou participação nas discussões e geração de
        ideias.
      </p>
    );
  } else if (percentage >= 30 && percentage <= 40) {
    return (
      <p>
        <strong> 30% a 40%: Atuação Básica</strong>: Execução de tarefas essenciais de menor complexidade.
      </p>
    );
  } else if (percentage >= 50 && percentage <= 60) {
    return (
      <p>
        <strong> 50% a 60%: Atuação Significativa</strong>: Envolvimento em tarefas importantes, que impactam diretamente nos
        resultados da realização.
      </p>
    );
  } else if (percentage >= 70 && percentage <= 80) {
    return (
      <p>
        <strong>70% a 80%: Atuação Substancial</strong>: Proatividade em aspectos específicos da realização ou resolução de
        desafios complexos.
      </p>
    );
  } else if (percentage >= 90) {
    return (
      <p>
        <strong>90% a 100%: Atuação Extraordinária</strong>:Condução global da realização destaque ou na solução de problemas
        críticos com sucesso.
      </p>
    );
  } else {
    return <p>Porcentagem inválida.</p>;
  }
};
